// 请求地址，区分开发环境和生产环境
let baseUrl: string;

if (process.env.NODE_ENV === 'production') {
  // 生产环境使用相对路径
  baseUrl = "/api";
} else {
  // 开发环境使用完整域名
  baseUrl = "https://test.11o.top/api";
}

export default baseUrl;